import React from 'react';
import { SignUpContent } from 'components/organisms/Contents/SignUpContent';
import { LoginLayout } from 'components/layouts/LoginLayout';

const SignUp = () => {
  return (
    <LoginLayout>
      <SignUpContent />
    </LoginLayout>
  );
};

export default SignUp;
